export default {
  recipeFilterNotAvailable: 'Wähle eine Anlage um den Rezeptfilter zu nutzen',
};
